<template>
  <div class="latest-work-order">
    <div class="table-container">
      <div class="table-group">
        <div class="table-header">
          {{ $t('analysisRequests.labels.date') }}
        </div>
        <div
          v-if="!isEmpty(onlyLastWorkOrder)"
          class="table-content"
        >
          {{ formatDate(onlyLastWorkOrder.creationDate) }}
        </div>
      </div>
      <div class="table-group">
        <div class="table-header">
          #{{ $t('siteDashboard.wo') }}
        </div>
        <div
          v-if="!isEmpty(onlyLastWorkOrder)"
          class="table-content"
        >
          {{ onlyLastWorkOrder.contractNumber }}
        </div>
      </div>
      <div class="table-group">
        <div class="table-header text-center">
          {{ $t('laboratory.labels.status') }}
        </div>
        <div
          v-if="!isEmpty(onlyLastWorkOrder)"
          class="table-content text-center"
        >
          <v-icon
            v-if="onlyLastWorkOrder.completionStatus === workOrderStatus.TODO"
            color="primary"
          >
            panorama_fish_eye
          </v-icon>
          <v-icon
            v-if="onlyLastWorkOrder.completionStatus === workOrderStatus.IN_PROGRESS"
            color="primary"
          >
            timelapse
          </v-icon>
          <v-icon
            v-if="onlyLastWorkOrder.completionStatus === workOrderStatus.PENDING"
            color="primary"
          >
            mdi-clock-outline
          </v-icon>
          <v-icon
            v-if="onlyLastWorkOrder.completionStatus === workOrderStatus.LATE"
            color="primary"
          >
            mdi-alert-circle-outline
          </v-icon>
        </div>
      </div>
      <div class="table-group">
        <div class="table-header text-center" />
        <div
          v-if="!isEmpty(onlyLastWorkOrder)"
          class="table-content goIcon"
        >
          <div
            class="edirect-icon"
            @click="goTo()"
          >
            <v-icon
              color="#154fe3"
            >
              mdi-arrow-top-right
            </v-icon>
            <span>go</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import workOrderStatus from '@/constants/workOrderStatusChoices';
import { isEmpty } from 'lodash';

export default {
    name: 'LastWorkOrder',
    props: {
        onlyLastWorkOrder: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        workOrderStatus() {
            return workOrderStatus;
        },
    },
    methods: {
        isEmpty,
        formatDate(date) {
            return date ? this.$options.filters.formatDate(date, 'L') : null;
        },
        goTo() {
            this.$router.push({
                name: 'WorkOrderView',
                params: {
                    clientId: this.onlyLastWorkOrder.site.client.ref,
                    siteId: this.onlyLastWorkOrder.site.ref,
                    workOrderId: this.onlyLastWorkOrder.id,
                    isEdition: true,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.table-container {
    display: flex;
    flex-wrap: wrap;
}
.table-group {
    flex: 1 1 25%;
    display: flex;
    flex-direction: column;
}
.table-header,
.table-content {
    padding: 10px;
}
.goIcon{
    display: flex;
    justify-content: center;
}
.edirect-icon{
    background-color: #e7edfc;
    padding: 0 .5rem 0 .5rem;
    border-radius: .5rem;
    color: #154fe3;
    font-size: 15px;
    font-weight: 500;
    width: 5rem;
    display: flex;
    column-gap: .5rem;
    justify-content: center;
    cursor: pointer;
}
.table-header {
    font-weight: bold;
    height: 2rem;
    border-bottom: 1px solid #ccc;
}
</style>
